import React, {
  forwardRef,
  useState,
  useMemo,
  useCallback,
  useRef,
} from "react";
import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";
import { FieldTypes } from "utils/formUtils";
import GenericMappingForm from "../GenericMappingForm";
import { isEmpty, uniqBy, split } from "utils/lodashUtils";
import message from "components/CustomMessage";

const TenableCloudSecurityMappingForm = forwardRef(function TenableCloudSecurityMappingForm({disableProjectFields = false, ...props }, ref) {
  const [mappedProjectList] = useState(() => {
    //using mappedProjectList to preserve the selected project when API fails
    if (props.record) {
      const { accountId } = props.record;
      return { accounts: split(accountId, ",").map(id => ({ id })) };
    }
    return { accounts: [] };
  });

  const accountRef = useRef({ accounts: mappedProjectList.accounts });

  const fetchProjects = useCallback(() => {
    const { promise, cancel } =
      ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, {
        login_id: props.loginConfigId,
      });
    promise
      .then((response) => {
        let { projects } = response;
        if (mappedProjectList["accounts"].length > 0 && !isEmpty(projects)) {
          response.projects = uniqBy(
            [...projects, ...mappedProjectList["accounts"]],
            "id"
          );
        }

        accountRef.current["accounts"] = response.projects;
      })
      .catch((err) => {
        message.error("Problem fetching accounts");
      });

    return { promise, cancel };
  }, [props.loginConfigId, props.toolName, mappedProjectList]);

  const getExtraFieldsData = useCallback((config) => {
    const { accountId } = config;
    return {
      accountId: accountId.join(),
      accountName: accountId.join(),
      ...(config.discovery_config_id && { discovery_config_id: config.discovery_config_id }),
    };
  }, []);

  const parseExtraFieldsDataFromResponse = useCallback((config) => {
    const { accountId} = config;
    return {
      accountId: split(accountId, ","),
      ...(config.discovery_config_id && { discovery_config_id: config.discovery_config_id }),
    };
}, []);

  const extraFields = useMemo(
    () => [
      {
        name: "accountId",
        colSpan: "12",
        type: FieldTypes.MULTI_SELECT,
        label: "Account",
        required: true,
        disabled: disableProjectFields,
        props: {
          autoFocus: !disableProjectFields,
          api: fetchProjects,
          parseSelectOptions: (res) =>
            res.projects.map((option) => {
              const { label = option.id, value = option.id } = option;
              return { label, value };
            }),
        },
      },
    ],
    [fetchProjects, disableProjectFields]
  );

  return (
    <GenericMappingForm
      ref={ref}
      getExtraFieldsData={getExtraFieldsData}
      extraFields={extraFields}
      parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
      {...props}
    />
  );
});

export default TenableCloudSecurityMappingForm;
